'use strict';

var _gas = require('dibs-tracking/gas');
var gtmDataLayer = require('dibs-tracking/gtmDataLayer');
var actFormRe = /\(([^\)]*)\)/i;
var labFieldRe = /^([^\(]*)/i;
var legacyPrefix = 'legacy ';

// TODO: figure out good way to not use actual account number while running tests
_gas.push(['_setAccount', 'UA-28839796-1']);
_gas.push(['_setDomainName', '.1stdibs.com']);
_gas.push(['_gasTrackForms']);
_gas.push(['_gasTrackOutboundLinks']);
_gas.push(['_gasTrackDownloads']);
_gas.push(['_gasTrackMailto']);

// Using gas trackEvent hook to push events to gtm dataLayer
_gas.push([
    '_addHook',
    '_trackEvent',
    function(cat, act, lab, val, noninteraction) {
        if (cat.toLowerCase() === 'outbound' && act.indexOf('1stdibs.com') >= 0) {
            return false;
        }

        // setting defaults
        lab = lab || undefined;
        val = val || 0;

        // noninteraction should default to 1 if undefined but falsy values should be 0
        noninteraction = noninteraction !== undefined && !noninteraction ? 0 : 1;

        // transform GAS form field tracking
        if (cat === 'Form Tracking') {
            cat = 'form field tracking';
            act = act.match(actFormRe)[1] + ' field change';
            lab = lab.match(labFieldRe)[0].trim();
        }

        // push to GTM dataLayer
        gtmDataLayer.push({
            event: 'e_ga_event',
            category: legacyPrefix + cat,
            action: act,
            label: lab,
            value: val,
            noninteraction: noninteraction,
        });

        // Cancel _gas call since we are now using GTM
        return false;
    },
]);

// Using gas trackPageview hook to push pageviews to gtm dataLayer
_gas.push([
    '_addHook',
    '_trackPageview',
    function(optPageURL) {
        // defaults
        optPageURL = optPageURL || location.href.split(location.host)[1];

        // push to GTM dataLayer
        gtmDataLayer.push({
            event: 'e_ga_pageview',
            opt_pageURL: legacyPrefix + optPageURL,
        });

        // Cancel _gas call since we are now using GTM
        return false;
    },
]);

// Using gas trackSocial hook to push socialEvents to gtm dataLayer
_gas.push([
    '_addHook',
    '_trackSocial',
    function(network, socialAction, optTarget, optPagePath) {
        // push to GTM dataLayer
        gtmDataLayer.push({
            event: 'e_ga_social',
            network: legacyPrefix + network,
            socialAction: socialAction,
            opt_target: optTarget || undefined,
            opt_pagePath: optPagePath || undefined,
        });

        // Cancel _gas call since we are now using GTM
        return false;
    },
]);



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/tracking/gas.setup.js
// module id = 4166
// module chunks = 62